import React from "react";
import { useTranslation } from "react-i18next";
interface IProps {
  isParentAccount: boolean;
  setIsParentAccount: React.Dispatch<React.SetStateAction<boolean>>;
}

function SignInToggleComponent(props: IProps) {
  const { i18n, t } = useTranslation();
  return (
    <div
      className={`${
        i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
      } flex justify-between items-center bg-zinc-100 w-[425px] h-14 rounded-2xl p-0.5 mt-4 mb-16 mobile:w-auto mobile:p-1`}
    >
      <button
        onClick={() => props.setIsParentAccount(!props.isParentAccount)}
        className={
          props.isParentAccount
            ? `font-arMedium text-2xl text-zinc50 bg-tart500 h-full w-[213px] rounded-2xl mobile:text-lg mobile:rounded-xl mobile:w-[50%]`
            : `font-arMedium text-2xl text-zinc400 w-[213px] mobile:text-lg mobile:w-[50%]`
        }
      >
        
        {t("app.shared.schoolOfficial")}
      </button>
      <button
        onClick={() => props.setIsParentAccount(!props.isParentAccount)}
        className={
          props.isParentAccount
            ? `font-arMedium text-2xl text-zinc400 w-[213px] mobile:text-lg mobile:w-[50%]`
            : `font-arMedium text-2xl text-zinc50 bg-tart500 h-full w-[213px] rounded-2xl mobile:text-lg mobile:rounded-xl mobile:w-[50%]`
        }
      >
        {t("app.shared.parentOrSturdnet")}
      </button>
    </div>
  );
}

export default SignInToggleComponent;
